export default __webpack_public_path__ + "static/media/me.f533c06b.png";